"use client";

import { twMerge } from "tailwind-merge";

import styles from "./ScrollDownButton.module.scss";

export const ScrollDownButton = () => (
  <button
    className={twMerge(
      "hidden w-fit flex-col items-center pt-7 lg:flex 2xl:pt-12",
      styles.container
    )}
    onClick={() => {
      document
        .getElementById("stock mining section")
        ?.scrollIntoView({ behavior: "smooth" });
    }}
  >
    <div className={styles.mouse}></div>
    <p className={styles.text}>Scroll</p>
  </button>
);
